<div class="templates-view">
  <div class="templates-header">
    <div>
      <h2 class="section-heading">Application Templates</h2>
      <p class="templates-subtitle">Create and manage country-specific application templates.</p>
    </div>
    @if (authorization.hasPermission(permissions.ScholarshipTemplateManage)) {
      <button type="button" class="btn btn-primary btn-lg" (click)="openCreateTemplateModal()">
        <i class="fas fa-plus"></i> New Template
      </button>
    }
  </div>

  @if (saveMessage) {
    <div class="alert alert-success" style="margin-bottom: 20px;">
      <i class="fas fa-check-circle"></i> {{ saveMessage }}
    </div>
  }

  <div class="card search-filter-card" style="margin-bottom: 20px;">
    <div class="card-body" style="padding: 20px;">
      <div class="search-filter-row">
        <div class="search-input-group">
          <label
          style="display: block; font-weight: bold; margin-bottom: 8px; font-size: 12px; color: var(--text-color);">SEARCH</label>
          <input type="text" class="form-control" [(ngModel)]="searchQuery" (ngModelChange)="onFiltersChanged()"
            placeholder="Name or country..."
            style="width: 100%; padding: 10px; border: 1px solid var(--medium-gray); border-radius: 3px; font-size: 14px;">
        </div>

        <div class="filter-group">
          <label
          style="display: block; font-weight: bold; margin-bottom: 8px; font-size: 12px; color: var(--text-color);">COUNTRY</label>
          <select class="form-control" [(ngModel)]="filterCountry" (ngModelChange)="onFiltersChanged()"
            style="width: 100%; padding: 10px; border: 1px solid var(--medium-gray); border-radius: 3px; font-size: 14px;">
            <option value="">All Countries</option>
            @for (country of countries; track country) {
              <option [value]="country.name">{{ country.name }}</option>
            }
          </select>
        </div>

        <div class="filter-group">
          <label
          style="display: block; font-weight: bold; margin-bottom: 8px; font-size: 12px; color: var(--text-color);">STATUS</label>
          <select class="form-control" [(ngModel)]="filterStatus" (ngModelChange)="onFiltersChanged()"
            style="width: 100%; padding: 10px; border: 1px solid var(--medium-gray); border-radius: 3px; font-size: 14px;">
            <option value="">All</option>
            <option value="COMPLETED">Completed</option>
            <option value="DRAFT">Draft</option>
          </select>
        </div>

        <button type="button" class="btn btn-primary btn-search" (click)="onFiltersChanged()" style="align-self: flex-end;">
          <i class="fas fa-search"></i> Search
        </button>
      </div>
    </div>
  </div>

  @if (availableDraft) {
    <div class="alert alert-warning" style="margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
      <span><span class="badge badge-warning">DRAFT</span> {{ availableDraft.displayName || 'Untitled template' }} is saved and ready to continue.</span>
      <button type="button" class="btn btn-secondary btn-sm" (click)="resumeDraft()">Resume draft</button>
    </div>
  }

  <div class="card">
    <div class="card-header">All Templates <span class="count-pill">{{ filteredTemplates.length }}</span></div>
    <div class="card-body" style="padding: 0;">
      <table class="table">
        <thead>
          <tr>
            <th>Template Name</th>
            <th>Country</th>
            <th>Grade Point Average</th>
            <th>Documents Required</th>
            <th>Status</th>
            <th>Modified</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (filteredTemplates.length === 0) {
            <tr>
              <td colspan="7" style="text-align: center; color: var(--text-color); padding: 40px; font-size: 14px;">No
                templates found.
              </td>
            </tr>
          }
          @for (template of paginatedTemplates; track template) {
            <tr>
              <td><strong>{{ template.name }}</strong></td>
              <td>
                <span
                  style="display: inline-flex; align-items: center; gap: 6px; color: var(--text-color); font-size: 13px;">
                  @if (getCountryFlagUrl(template.country.name)) {
                    <img
                      [src]="getCountryFlagUrl(template.country.name)" [alt]="template.country.name + ' flag'"
                      width="16" height="12" style="border: 1px solid #ddd; border-radius: 2px;">
                  }
                  @if (template.country.code) {
                    <strong style="margin-right: 2px;">{{
                    template.country.code }}</strong>
                  }
                  {{ template.country.name }}
                </span>
              </td>
              <td>{{ template.gradePointAverage.minimumPercentage !== null ? template.gradePointAverage.minimumPercentage + '%' : '-' }}</td>
              <td>
                @for (documentTypeName of getDistinctDocumentTypeNames(template); track documentTypeName) {
                  <span class="doc-chip">{{ documentTypeName }}</span>
                }
              </td>
              <td>
                <span class="badge" [class.badge-success]="getTemplateStatus(template) === 'COMPLETED'"
                  [class.badge-warning]="getTemplateStatus(template) === 'DRAFT'">
                  {{ getTemplateStatus(template) }}
                </span>
              </td>
              <td style="font-size: 13px; color: var(--text-color);">{{ currentDate | date: 'dd MMM yyyy' }}</td>
              <td>
                @if (authorization.hasPermission(permissions.ScholarshipTemplateManage)) {
                  <a href="#" (click)="$event.preventDefault(); openTemplateForEdit(template.id)"
                  style="color: var(--primary-blue); text-decoration: none; font-size: 13px; font-weight: 500;">Edit</a>
                }
                @if (authorization.hasPermission(permissions.ScholarshipTemplateManage)) {
                  <span style="margin: 0 6px; color: var(--medium-gray);">|</span>
                }
                @if (authorization.hasPermission(permissions.ScholarshipTemplateManage)) {
                  <a href="#" (click)="$event.preventDefault(); requestDeleteTemplate(template.id)"
                  style="color: #d9534f; text-decoration: none; font-size: 13px; font-weight: 500;">Delete</a>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [totalItems]="filteredTemplates.length"
        [showingFrom]="showingFrom" [showingTo]="showingTo" itemLabel="templates"
      (pageChange)="goToPage($event)"></app-pagination>
    </div>
  </div>
</div>

@if (showDeleteTemplateConfirm) {
  <div class="modal-overlay" (click)="cancelDeleteTemplate()">
    <div class="modal-content" style="max-width: 420px;" role="dialog" aria-modal="true" aria-labelledby="delete-modal-title" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="modal-title" id="delete-modal-title">Delete Template</div>
        <button type="button" class="modal-close" (click)="cancelDeleteTemplate()">&times;</button>
      </div>
      <div class="modal-body">
        @if (deleteErrorMessage) {
          <div class="alert alert-danger" style="margin-bottom: 12px;">
            <i class="fas fa-exclamation-circle"></i> {{ deleteErrorMessage }}
          </div>
        }
        <p style="margin: 0; font-size: 15px; color: var(--dark-gray);">
          Are you sure you want to delete this template? This action cannot be undone.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancelDeleteTemplate()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="confirmDeleteTemplate()">Delete</button>
      </div>
    </div>
  </div>
}

@if (showCreateTemplateModal) {
  <div class="modal-overlay" (click)="closeCreateTemplateModal()">
    <div class="modal-content template-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="modal-title">{{ editingTemplateId ? 'Edit Application Template' : 'Create New Application Template' }}
        </div>
        <button type="button" class="modal-close" (click)="closeCreateTemplateModal()">&times;</button>
      </div>
      <div class="modal-body">
        @if (draftMessage) {
          <div class="alert alert-success" style="margin-bottom: 16px;"><i class="fas fa-check-circle"></i> {{ draftMessage }}</div>
        }
        @if (errorMessage) {
          <div class="alert alert-danger" style="margin-bottom: 16px; white-space: pre-line;">
            <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
          </div>
        }
        <div class="card" style="margin-bottom: 20px;">
          <div class="card-header">Basic Information</div>
          <div class="card-body">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
              <div>
                <label style="display: block; font-weight: bold; margin-bottom: 5px;">Template Name <span
                style="color: red;">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="templateName"
                  placeholder="Standard Application - South Africa"
                  style="width: 100%; padding: 8px; border: 1px solid var(--medium-gray); border-radius: 3px;">
              </div>
              <div>
                <label style="display: block; font-weight: bold; margin-bottom: 5px;">Target Country <span
                style="color: red;">*</span></label>
                <select class="form-control" [(ngModel)]="targetCountryId"
                  style="width: 100%; padding: 8px; border: 1px solid var(--medium-gray); border-radius: 3px;">
                  <option [ngValue]="null">-- Select Country --</option>
                  @for (country of countries; track country) {
                    <option [ngValue]="country.id">{{ country.name }}</option>
                  }
                </select>
              </div>
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
              <div>
                <label style="display: block; font-weight: bold; margin-bottom: 5px;">Minimum Average (%) <span
                style="color: red;">*</span></label>
                <select class="form-control" [(ngModel)]="gradePointAverageId"
                  style="width: 100%; padding: 8px; border: 1px solid var(--medium-gray); border-radius: 3px;">
                  <option [ngValue]="null">-- Select Minimum Average--</option>
                  @for (gradePointAverage of gradePointAverages; track gradePointAverage) {
                    <option [ngValue]="gradePointAverage.id">
                      {{
                      formatGradePointAverageRange(gradePointAverage.minimumPercentage,gradePointAverage.maximumPercentage)
                      }}
                    </option>
                  }
                </select>
                <small style="color: var(--text-color); font-size: 11px;">Select range which starts with your
                minimum</small>
              </div>
            </div>
            <div>
              <label style="display: block; font-weight: bold; margin-bottom: 5px;">Description</label>
              <textarea class="form-control" [(ngModel)]="templateDescription" rows="2"
                placeholder="Brief description of this template..."
              style="width: 100%; padding: 8px; border: 1px solid #E0E0E0; border-radius: 3px; resize: vertical;"></textarea>
            </div>
          </div>
        </div>
        <div class="card form-builder-card" style="margin-bottom: 20px;">
          <div class="card-header form-builder-header">
            <span>Application Fields - Form Builder</span>
            <small>{{ fields.length }} fields added</small>
          </div>
          <div class="card-body">
            <div class="form-builder-info">
              <i class="fas fa-info-circle"></i>
              Use "+ Add Field" to build the form applicants will fill in. Set label and field type for each field.
            </div>
            <table class="table form-builder-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Field Label</th>
                  <th>Field Type</th>
                  <th>Required</th>
                  <th>Category</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                @if (fields.length === 0) {
                  <tr>
                    <td colspan="6" style="text-align: center; color: var(--text-color); padding: 20px;">No fields added
                      yet. Click "+
                    Add Field" to begin.</td>
                  </tr>
                }
                @for (field of fields; track field; let i = $index) {
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td>
                      <input type="text" class="form-control" [(ngModel)]="field.label" placeholder="e.g. Identity Number">
                      @if (requiresOptions(field.fieldType.name)) {
                        <input type="text" class="form-control"
                          [(ngModel)]="fieldOptionsText[i]"
                          placeholder="Options (comma separated): e.g. Mr,Mrs,Ms,Dr" style="margin-top: 6px;">
                      }
                    </td>
                    <td>
                      <select class="form-control" [(ngModel)]="field.fieldType.name"
                        (ngModelChange)="onFieldDefinitionChanged(i)">
                        @if (fieldTypeOptions.length === 0) {
                          <option value="text">Select Option</option>
                        }
                        @for (typeOption of fieldTypeOptions; track typeOption) {
                          <option [value]="typeOption">{{ typeOption }}</option>
                        }
                      </select>
                    </td>
                    <td><input type="checkbox" [(ngModel)]="field.isRequired"></td>
                    <td>
                      <select class="form-control" [(ngModel)]="field.fieldCategory.name"
                        (ngModelChange)="onFieldDefinitionChanged(i)">
                        @for (category of categoryOptions; track category) {
                          <option [value]="category">{{ category }}</option>
                        }
                      </select>
                    </td>
                    <td>
                      <button type="button" class="btn btn-danger btn-sm remove-field-btn" (click)="removeTemplateField(i)"
                        aria-label="Remove field">
                        <i class="fas fa-times"></i>
                        <span>Remove</span>
                      </button>
                    </td>
                  </tr>
                  <tr class="insert-field-row">
                    <td colspan="6">
                      <button type="button" class="btn-insert-field" (click)="insertTemplateField(i)" title="Insert field here" aria-label="Insert field here">
                        <i class="fas fa-plus"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <button type="button" class="btn btn-secondary" (click)="addTemplateField()" style="margin-top: 10px;">
              <i class="fas fa-plus"></i> Add Field
            </button>
            <button type="button" class="btn btn-primary" (click)="loadDhetRequiredFieldSet()"
              style="margin-top: 10px; margin-left: 8px;">
              <i class="fas fa-layer-group"></i> Load DHET Required Fields
            </button>
            <button type="button" class="btn btn-secondary" (click)="loadRequiredDocuments()"
              style="margin-top: 10px; margin-left: 8px;">
              <i class="fas fa-layer-group"></i> Load Required Documents
            </button>
          </div>
        </div>
        <div class="card" style="margin-bottom: 0;">
          <div class="card-header">Required Documents</div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Document Type</th>
                  <th style="width: 90px; text-align: center;">Required</th>
                  <th style="width: 220px;">Allowed Formats</th>
                </tr>
              </thead>
              <tbody>
                @for (selection of documentTypeSelections; track selection) {
                  <tr>
                    <td>{{ selection.documentType.name }}</td>
                    <td style="text-align: center;">
                      <input type="checkbox" [(ngModel)]="selection.isRequired" [ngModelOptions]="{standalone: true}">
                    </td>
                    <td>
                      <select class="form-control" multiple style="padding: 4px 8px; font-size: 13px;"
                        [(ngModel)]="selection.allowedFormatIds" [ngModelOptions]="{standalone: true}">
                        @for (format of documentFormats; track format) {
                          <option [ngValue]="format.id">
                            {{ format.name
                            }} ({{ format.fileExtension }}) |
                          {{format.documentFormatCategory.name}}</option>
                        }
                      </select>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="resetTemplateForm()">Clear Form</button>
        <button type="button" class="btn btn-secondary" (click)="saveDraft()"><i class="fas fa-save"></i> Save Draft</button>
        <button type="button" class="btn btn-primary" (click)="createTemplate()">
          <i class="fas fa-save"></i> {{ editingTemplateId ? 'Update Template' : 'Create Template' }}
        </button>
      </div>
    </div>
  </div>
}
